import  { combineReducers } from 'redux';
import { AgentReducers } from './agentReducers';

export default combineReducers({
    AgentReducers,
});